import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate} from "react-router-dom";
import Swal from 'sweetalert2';

import helpers from '../../helpers/helpers';
import images from '../../helpers/images';
import appConfig from '../../config/env';
import { httpRequest } from '../../helpers/httpService';
import appSession from '../../helpers/session';
import RenderErrors from '../elements/RenderErrors';
import InputText from '../elements/InputText';
import Loader from './Loader';

function LoginForm({title = '', redirect_to = '/'}){
    let { event_id } = useParams();
    const [errors, setErrors] = useState([]);
    
    const [login_data, setLogin] = useState({
        email: '',
        password: '',
    });

    const [loading, setLoading] = useState(0);

    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        let new_state = { [name]: value }

        setLogin({ ...login_data, ...new_state });
    }

    function attemptLogin(type = ''){
        let form_data = {...login_data};
        form_data.login_type = type;

        const url = appConfig.apiUrl + '/account/signin';

        setLoading(1)

        httpRequest(url, "POST", {
            postdata: { 
                ...form_data, 
            },
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                appSession.setSession(res.data.access_token, res.data.permissions, res.data.user)
                setLoading(0)

                Swal.fire({
                    title: "Success!",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(redirect_to == 'current'){
                            window.location.reload(false);
                        }else{
                            window.location.href = redirect_to;
                        }
                    }
                })

            })
            .catch((err) => {
                setLoading(0)
                let title = 'Error!'
                if(err.data){
                    setErrors( err.data );
                    err.message = "Please check your entry";
                }

                if(err.status == 'pending-activation'){
                    title = 'Activation Required!'
                }
      
                Swal.fire({
                    title: title,
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            });
    }
    
    return (
        <div>

            <form action="/" method="post">
                <Loader isLoading={loading}/>
                {title ? <h4 className="faith-login-title mt-3 px-3">{title}</h4>: ''} 
                <div className="container mt-3">
                    <div className='mb-3'>
                    <InputText
                        id={'email'} 
                        name={'email'} 
                        value={login_data.email}    
                        label='Email Address'
                        tagClass="form-control"
                        onChange={inputChange}
                        //onChange={(e) => setLoginEmail(e.target.value)}
                        placeholder='Enter your email'
                    />
                    <RenderErrors 
                        errors={errors} 
                        name="email" 
                        className="text-danger fs-7"
                    />
                    </div>

                    <div className='mb-2'>
                        <InputText
                            id={'password'} 
                            name={'password'}
                            value={login_data.password} 
                            label='Password'
                            tagClass="form-control"
                            type='password'
                            onChange={inputChange}
                            //onChange={(e) => setLoginPassword(e.target.value)}
                            placeholder='Enter your password'
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="email" 
                            className="text-danger fs-7"
                        />
                    </div>

                    <Link to='/recover-password'>Forgot Password?</Link>
                </div>
                <div className="container d-flex justify-content-end">
                    <button type="button" className="cancelbtn me-3" style={{width: '170px'}}  onClick={(e) => attemptLogin('myspon')}>Login using Myspon</button>
                    <button type="button" className="cancelbtn"  onClick={(e) => attemptLogin('user')}>Login</button>
                </div>
            </form>
        </div>
    )
}

export default LoginForm;